import { enableScreens } from 'react-native-screens';

enableScreens();
